The type of the question response.

Currently, two codes are defined:

- `MultiSelect` for choosing one or more responses from `responseChoice`.
- `SingleSelect` for choosing a single response from `responseChoice`.
